import React$1 from 'react';

const Linkedin = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}, /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  fillRule: "evenodd",
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm6.139 15c-2.278 0-3.64 1.316-4.195 2.212h-.083l-.195-1.904H18c.055 1.232.111 2.66.111 4.368V29h4.222v-7.896c0-.392.028-.784.14-1.064.305-.784 1-1.596 2.166-1.596 1.528 0 2.139 1.204 2.139 2.968V29H31v-8.092C31 16.876 28.917 15 26.139 15zM15 15h-4v14h4V15zm-1.988-6C11.795 9 11 9.868 11 11c0 1.105.77 2 1.963 2C14.23 13 15 12.105 15 11c-.025-1.132-.77-2-1.988-2z"
}));

export default Linkedin;
